<template>
  <div class="app" :class="appClasses">
    <router-view />
    <loader />
    <migration-process v-if="isEditorAndDesignEditor" />
  </div>
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
/* eslint-disable vue/component-definition-name-casing */
import ActionButtons from '@/js/components/editor/nodes/ActionButtons.vue'
import BrandLogo from '@/js/components/editor/nodes/BrandLogo.vue'
import BuyNowButton from '@/js/components/editor/nodes/BuyNowButton.vue'
import CButton from '@/js/components/editor/nodes/CButton.vue'
import CForm from '@/js/components/editor/nodes/CForm.vue'
import CImage from '@/js/components/editor/nodes/CImage.vue'
import CSurvey from '@/js/components/editor/nodes/CSurvey.vue'
import CVideo from '@/js/components/editor/nodes/CVideo.vue'
import Divider from '@/js/components/editor/nodes/Divider.vue'
import Draft from '@/js/components/editor/nodes/DraftFroala.vue'
import CvtIcon from '@/js/components/editor/nodes/icon/Icon.vue'
import SubGridContainer from '@/js/components/editor/nodes/SubGridContainer.vue'
import Vue from 'vue'
import AssetManager from './components/asset-manager/Manager.vue'
import Anime from './components/common/Anime.vue'
import AnimeGroup from './components/common/AnimeGroup.vue'
import Icon from './components/common/Icon.vue'
import MainNav from './components/common/MainNav.vue'
import FadeInOut from './components/common/transitions/FadeInOut.vue'
import UrlInput from './components/common/UrlInput.vue'
import AdvancedSideMenu from './components/editor/advanced-side-menu/AdvancedSideMenu.vue'
import FormEditor from './components/editor/forms/FormEditor.vue'
import IconPicker from './components/editor/IconPicker.vue'
import CPopupBuilder from './components/editor/nodes/CPopupBuilder.vue'
import DragAndDropZone from './components/editor/nodes/DragAndDropZone.vue'
import DragItems from './components/editor/nodes/DragItems.vue'
import VNodeBtn from './components/editor/nodes/VNodeBtn.vue'
import VNodeBtnGroup from './components/editor/nodes/VNodeBtnGroup.vue'
import VNodeDragHandle from './components/editor/nodes/VNodeDragHandle.vue'
import VNodeLabel from './components/editor/nodes/VNodeLabel.vue'
import VNodeOverlay from './components/editor/nodes/VNodeOverlay.vue'
import VNodePush from './components/editor/nodes/VNodePush.vue'
import QuickLaunchBlock from './components/editor/quick-launch/QuickLaunchBlockFull.vue'
import SaveBlock from './components/editor/SaveBlock.vue'
import SwapBlock from './components/editor/SwapBlock.vue'
import SiteSettings from './components/editor/SiteSettings.vue'
import ImageSearch from './components/ImageSearch.vue'
import Loader from './components/Loader.vue'
import FroalaView from "./components/froal-component/vue-froala-view.vue"
import FroalaWrapper from "./components/froal-component/vue-froala.vue"
import './components/v3'

Vue.component('Anime', Anime)
Vue.component('AnimeGroup', AnimeGroup)
Vue.component('Icon', Icon)
Vue.component('UrlInput', UrlInput)
Vue.component('MainNav', MainNav)
Vue.component('VnodeLabel', VNodeLabel)
Vue.component('VnodeDragHandle', VNodeDragHandle)
Vue.component('VnodePush', VNodePush)
Vue.component('VnodeOverlay', VNodeOverlay)
Vue.component('VnodeBtn', VNodeBtn)
Vue.component('VnodeBtnGroup', VNodeBtnGroup)
Vue.component('AdvancedSideMenu', AdvancedSideMenu)
Vue.component('FormEditor', FormEditor)
Vue.component('IconPicker', IconPicker)
Vue.component('QuickLaunchBlock', QuickLaunchBlock)
Vue.component('DragAndDropZone', DragAndDropZone)
Vue.component('SwapBlock', SwapBlock)
Vue.component('SaveBlock', SaveBlock)
Vue.component('Loader', Loader)
Vue.component('ImageSearch', ImageSearch)
Vue.component('SiteSettings', SiteSettings)
Vue.component('AssetManager', AssetManager)
Vue.component('FadeInOut', FadeInOut)
Vue.component('CButton', CButton)
Vue.component('Draft', Draft)
Vue.component('CImage', CImage)
Vue.component('CSurvey', CSurvey)
Vue.component('Divider', Divider)
Vue.component('CVideo', CVideo)
Vue.component('CForm', CForm)
Vue.component('Icon', CvtIcon)
Vue.component('BrandLogo', BrandLogo)
Vue.component('BuyNowButton', BuyNowButton)
Vue.component('ActionButtons', ActionButtons)
Vue.component('CPopupBuilder', CPopupBuilder)
Vue.component('SubGridContainer', SubGridContainer)
Vue.component('DragItems', DragItems)
Vue.component('FroalaView', FroalaView)
Vue.component('FroalaWrapper', FroalaWrapper)

Vue.directive('intersected-once', {
  inserted(el, { value }) {
    const { onIntersected, shouldObserve } = value

    if (shouldObserve === false) {
      return
    }

    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries
      if (entry && entry.isIntersecting) {
        observer.disconnect()
        onIntersected()
      }
    })
    observer.observe(el)
  },
})
export default {
  name: 'App',
  computed: {
    appClasses() {
      return {
        'app--header': true,
        'app--header--editor': this.isEditor,
      }
    },
    isEditor() {
      return this.$route.matched.some((m) => m.meta.editor)
    },
    isEditorAndDesignEditor() {
      return this.isEditor && this.$route.name === 'editor:design:page'
    },
  },
  mounted() {
    // Notify parent that iframe is ready to receive messages
    window.parent.postMessage('IFRAME_READY', '*');

    window.addEventListener('message',
        (event) => {
          if (event.data?.type === 'SET_THEME') {
            let mode = event.data.mode;
            let theme = event.data.theme;
            if (mode === 'dark' || mode === 'light' || mode === 'system') {
              if (mode === 'system') {
                mode = "light"
              }
              if(document.body.classList.contains(mode)){
                if(mode === "dark"){
                  document.body.classList.replace("light","dark");
                }
                else{
                  document.body.classList.replace("dark","light");
                }
              }else{
              document.body.classList.add(mode);
            }
            if(!document.body.classList.contains("custom-builder-theme")){
              document.body.classList.add("custom-builder-theme");
            }

            }
            if(theme){
              Object.keys(theme).forEach((key) => {
                if(!document.body.style.getPropertyValue(key)){
                  document.body.style.setProperty(key, theme[key]);
                }else{
                  document.body.style.removeProperty(key);
                  document.body.style.setProperty(key, theme[key]);
                }
              });
            }
          }
        }
      )
  },

}
</script>

<style lang="scss">
@import 'bootstrap';
@import '@/scss/utils';
@import 'vue2-animate/dist/vue2-animate.min';
@import '@/scss/breakpoint';

$light-primary-hover-bg: #F0F2F6;
$dark-primary-hover-bg: #F0F2F6;
$light-border: #CDD7E1;
$dark-border: #32383E;
$dark-hover-bg: #171A1C;

.el-upload__input {
  display: none !important;
}

body,
html {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
}

.app-bg {
  background-color: $dark-gray;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Light mode override */
@media (prefers-color-scheme: light) {
  body.custom-builder-theme {
    background-color: #FFF;
    // color: #171A1C;

    // buttons
    .cvt-dialog-wrapper button, .cvt-top-nav-bar button, .cvt-left-side-bar button, .cvt-left-nav button, .cvt-properties-sidebar button,.marketplace-wrapper button, .el-dialog  button, .landing-page-description-wrapper button,
    .select-industry-container button, .landingpage-goal-container button, .bp-container button, .cvt-launch-container button {
      background-color: var(--primary-color);
      color: rgba(0, 0, 0, 0.56);
      border-color: var(--primary-color);
      span,i {
        color: #FFF;
      }

      &.actionIcon:hover {
        background-color: #FFF;
      }
      &.disabled{
        background-color: #FFF;
        color: rgba(0, 0, 0, 0.12);
        border-color: rgba(0, 0, 0, 0.87);
        span,i {
          color: rgba(0, 0, 0, 0.12);
        }
      }
      &.outline{
        border: 1px solid var(--primary-color);
        background-color: $light-primary-hover-bg;
        color: var(--primary-color);

        span,i {
          color: var(--primary-color);
        }
      }

      &:hover:not(.disabled), &:focus:not(.disabled), &:active:not(.disabled){
        border: 1px solid var(--primary-color);
        background-color: #CDD7E1 ;
        color: var(--primary-color);

        span,i {
          color: var(--primary-color);
        }
      }
    }

    // switch
    .cvt-switch{
      background-color: #E2E6ED;
      border-color: #E2E6ED;
      span{
          color: #FFF;
        }

      &[type="rounded"]{
        background-color: #cdd7e1;
        border-color: #cdd7e1;
        span{
          color: #32383e;
        }
      }

      &.active:not([type="rounded"]){
        background-color: var(--primary-color);
        border-color: var(--primary-color);

      }
      &.disabled{
        background-color: #f0f0f0;
        border-color: #f0f0f0;
      }
    }

     // radio button
    .cvt-dialog-wrapper .cvt-radio-group, .cvt-top-nav-bar .cvt-radio-group, .cvt-properties-sidebar .cvt-radio-group, .cvt-launch-container .cvt-radio-group{
      background-color: #FFF;
      color: #32383E;
      border-radius: 8px;
      border-color: #CDD7E1;

      .cvt-radio-btn{
        background-color: #CDD7E1;
        color: #32383E;
        border-width: .5px;

        span{
          border-color: #CDD7E1;
        }

        &.active, &:hover{
          background-color: #FFF;
          border-color: #CDD7E1;

        }
      }
    }
    .cvt-radio-group[type="multiselect"], .cvt-radio-group[type="multiselect"] {
      border: 1px solid #CDD7E1 !important;
      border-radius: unset;
    }

    // select input
    .cvt-select-input-group.focus{
      border-color: var(--primary-color);
    }

    // top nav
    .cvt-top-nav-bar {
      background-color: #F0F4F8;
      border-bottom: 1px solid #CDD7E1;

      div{
        color: #171A1C;
      }
    }

    // left nav
    .cvt-left-nav {
      background-color: #FFF;
      color: rgba(0, 0, 0, 0.87);
      border-right: 1px solid #CDD7E1;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);

      > div {
        &.isActive {
          background-color: #F0F4F8;

          span,i {
            color: var(--primary-color);
          }
        }
        span,i {
          color: rgba(0, 0, 0, 0.56);
        }
      }
      span {
        color: #171A1C;
      }
    }

    // left side bar
    .cvt-left-side-bar{
      border-right: 1px solid $light-border;
      .cvt-left-side-bar-item-container{
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
      }
      .cvt-left-side-bar-item{
          color: rgba(0, 0, 0, 0.56);

        &.active, &:hover{
          background-color: #F0F4F8;
          span,i {
            color: var(--primary-color);
          }
        }
      }
      * {
        border-color:  $light-border;
      }
    }

    // properties sidebar
    .cvt-properties-sidebar{

      .cvt-slider{

        .cvt-slider-fill{
          background-color: var(--primary-color);
        }
        .cvt-slider-knob{
          border-color: var(--primary-color);
        }
      }
    }

    // select industry
    .select-industry-container{

      .select-industry-card{
        border-color: #bcc2cb;

        i,span,p,h1{
          color: #171a1c;
        }
      }
      .select-industry-card[isactive="true"]{
        border-color: var(--primary-color);
        i,span,p,h1{
            color: var(--primary-color);
          }
      }
    }

    // landing page goal
    .landingpage-goal-container{
      .landingpage-goal-card{
        border-color: #bcc2cb;

        i,span,p,h1{
          color: #171a1c;
        }
      }
      .landingpage-goal-card[isactive="true"]{
        border-color: var(--primary-color);
        i,span,p,h1{
            color: var(--primary-color);
          }
      }
    }

    // brand preference
    .bp-container{
      background-color: #FFF;
    }

    .marketplace-wrapper{
      .marketplace-tag-container{
        .marketplace-tag{
          background-color: var(--primary-color);
          color: #FFF;
        }
      }
      .cvt-tabs-nav-wrapper{
          a{
            &[isactive="true"], &:hover{
              border-color: var(--primary-color);
              background-color: var(--primary-color);
              color: #FFF;
            }
          }
      }
    }
  }
}

/* Dark mode override */
@media (prefers-color-scheme: dark) {
  body.custom-builder-theme {
    background-color: #121212;
    // color: #ffffff;

    // scrollbar
    ::-webkit-scrollbar{
      background-color: #121212;
      width: 6px;

    }
    ::-webkit-scrollbar-thumb{
      background-color: #32383E;
      border-radius: 10px;
    }

    .loader-wrapper{
      background-color: #121212;
      h2{
        color: #FFF;
      }
    }

    // buttons
    .cvt-dialog-wrapper button, .cvt-top-nav-bar button, .cvt-left-nav button, .cvt-left-side-bar button, .cvt-properties-sidebar button, .marketplace-wrapper button, .el-dialog  button, .landing-page-description-wrapper button,
    .select-industry-container button,  .landingpage-goal-container button, .bp-container button, .cvt-launch-container button {
      background-color: var(--primary-color);
      color: rgba(0, 0, 0, 0.56);
      border-color: var(--primary-color);
      span,i {
        color: #FFF;
      }

      &.actionIcon:hover {
        background-color: #FFF;
      }
      &.disabled{
        background-color: rgba(0, 0, 0, 0.87);
        color: rgba(255, 255, 255, 0.12);
        border-color: rgba(0, 0, 0, 0.87);
        span,i {
          color: rgba(255, 255, 255, 0.12);
        }
      }

      &:hover:not(.disabled), &:focus:not(.disabled), &:active:not(.disabled){
        border: 2px solid var(--primary-color);
        background-color: #CDD7E1 ;
        color: var(--primary-color);

        span,i {
          color: var(--primary-color);
        }
      }

      &.outline{
        border: 2px solid var(--primary-color);
        background-color: #FFF ;
        color: var(--primary-color);

        span,i {
          color: var(--primary-color);
        }
      }
    }

     // switch
     .cvt-switch{
      background-color: #E2E6ED;
      border-color: #E2E6ED;
      span{
        color: #FFF;
      }

      &[type="rounded"]{
        background-color: #cdd7e1;
        border-color: #cdd7e1;
        span{
          color: #32383e;
        }
      }

      &.active:not([type="rounded"]){
        background-color: var(--primary-color);
        border-color: var(--primary-color);

      }
      &.disabled{
        background-color: #f0f0f0;
        border-color: #f0f0f0;
      }
    }

    // radio group
    .cvt-dialog-wrapper .cvt-radio-group, .cvt-top-nav-bar .cvt-radio-group, .cvt-properties-sidebar .cvt-radio-group, .marketplace-wrapper .cvt-radio-group, .cvt-launch-container .cvt-radio-group{
      background-color: #121212;
      color: #F0F4F8;
      border-radius: 8px;


      .cvt-radio-btn{
        border-color: #32383E;
        background-color: #555E68;
        color: #CDD7E1;

        &.active, &:hover{
          background-color: #171A1C;
        }
      }
    }

    .cvt-select-input-group{
      .focus{
        border-color: var(--primary-color);
      }
      span{
          color:#32383e !important;
        }
    }

    // top nav
    .cvt-top-nav-bar {
      background-color: #171A1C;
      border-bottom: 1px solid #32383E;

      div {
        color: #F0F4F8;
      }
    }

    // left nav
    .cvt-left-nav {
      background-color: #121212;
      color: #F0F4F8;
      border-right: 1px solid #32383E;

      div {
        &.isActive {
          background-color: $dark-hover-bg;

          span,i {
            color: var(--primary-color);
          }
        }
        span,i {
          color: rgba(255, 255, 255, 0.56);
        }
      }

      span {
        color: #F0F4F8;
      }
    }

    // dialog wrapper
    .cvt-dialog-wrapper{

      h5,span,h1,label, small{
        color: #FFF;
      }

      .integrations-wrapper{
        background-color: #121212;
      }
      .brand-block {
        background-color: #121212 !important;
      }

      .cvt-dialog-content{
        background-color: #121212;
        border-color: $dark-border;

        .cvt-tabs-nav-wrapper{
          background-color: #121212;
          ul a:not([isactive="true"]){
            background-color: #121212;
            color: #FFF;

          }
          ul a[isactive="true"]{
            background-color: #121212;
            color: var(--primary-color);
            border-color:var(--primary-color);
          }
          ul a:not([isactive="true"]):hover{
            background-color: #171A1C;
            color:var(--primary-color);
            border-color:var(--primary-color);

          }
        }
        .cvt-settings-title{
          background-color: #121212;
          color: #F0F4F8;
        }
      }

      .cvt-dialog-header, .cvt-dialog-footer{
        border-color: $dark-border;
      }
    }

    .el-dialog{
      background-color: #121212;
      color: #FFF;
    }

    // drop down menu
    .cvt-drop-down-menu-container{
      span{
        color: #121212 !important;
      }
    }

    // marketplace wrapper
    .marketplace-wrapper{
      .marketplace-templates span{
        color: #FFF;
      }

      .cvt-search-style{
        background-color: #121212;
        border-color: $dark-border;
        span{
          color: #FFF;
        }
      }

      [identity="FormGroup"] label {
        color: #FFF;
      }
      .brand-block {
        background-color: #121212;
        color: #FFF;
        border-color: $dark-border;
      }

      .marketplace-tag-container{
        .marketplace-tag{
          background-color: var(--primary-color);
          color: #FFF;
        }
      }
      .cvt-tabs-nav-wrapper{
          a{
            &[isactive="true"], &:hover{
              border-color: var(--primary-color);
              background-color: var(--primary-color);
              color: #FFF;
            }
          }
      }
    }

    // landing page description wrapper
    .landing-page-description-wrapper{
      background-color: #121212;

      h1,p{
        color: #FFF;
      }
      .landingpage-description-textbox-wrap p{
        color: #FFF;
      }
      .landingpage-description-help-text{
        i,span{
          color: #FFF;
        }
      }
    }

    // select industry container
    .select-industry-container{
      background-color: #121212;

      h1, label{
        color: #FFF;
      }

      .select-industry-card{
        border-color: #FFF;

        i,span,p,h1{
          color: #FFF;
        }
      }
      .select-industry-card[isactive="true"]{
        border-color: var(--primary-color);
        i,span,p,h1{
            color: var(--primary-color);
          }
      }
    }

    .landingpage-goal-container{
      background-color: #121212;

      h1, label{
        color: #FFF;
      }
      .landingpage-goal-card{
        border-color: #FFF;

        i,span,p,h1{
          color: #FFF;
        }
      }
      .landingpage-goal-card[isactive="true"]{
        border-color: var(--primary-color);
        i,span,p,h1{
            color: var(--primary-color);
          }
      }
    }

    // left side bar
    .cvt-left-side-bar{
      background-color: #121212;
      border-right: 1px solid $dark-border;

      .cvt-left-side-bar-item-container{
        border-right: 1px solid $dark-border;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
      }
      .cvt-left-side-bar-item{
          color: rgba(255, 255, 255, 0.56);

        &.active, &:hover{
          background-color: $dark-hover-bg;
          span,i {
            color: var(--primary-color);
          }
        }
      }
      [data-identity="cvt-sections"] .cvt-section-form-group label{
        color: #F0F4F8;
      }
      .cvt-section-wrapper, .cvt-bookmark-wrapper{
        color: #F0F4F8;
        i, span{
          color: #F0F4F8;
        }
      }
      .layout-section{
        border-color:  $dark-border;
        color: #F0F4F8;

        &[active="true"]::before{
          background-color: $dark-hover-bg;
        }

        &:hover {
          &::before {
            background-color: $dark-hover-bg;
          }
        }

      }
      .ssd-wrapper  p{
        color: #F0F4F8;
      }
      *{
        border-color: $dark-border;
      }
    }

    // properties sidebar
    .cvt-properties-sidebar {
      background-color: #121212;
      border-color: $dark-border;

      .cvt-collapse-item{
        background-color: #121212;
        color: #F0F4F8;

        .cvt-collapse-head{
          background-color: #171A1C;
          color: rgba(255, 255, 255, 0.56);
        }
        .cvt-collapse-content{
          background-color: #121212;
          color: #F0F4F8;

          small, strong, p, label, div{
            color: #F0F4F8;
          }
          i{
            color: var(--primary-color);
          }
        }
        &.is-active{
          background-color: #171A1C;
        }
      }
      .bookmark-wrap, .footer-item{
        &:hover{
          background-color: $dark-hover-bg;
          color: #FFF;
        }
      }
      * {
        border-color: $dark-border;
      }
    }

    // slider
    .cvt-slider{
      .cvt-slider-fill{
        background-color: var(--primary-color);
      }
      .cvt-slider-knob{
        border-color: var(--primary-color);
      }
    }

    // brand preference
    .bp-container{
      background-color: #121212;

      .bp-header{
        h1, label, p{
          color: #FFF;
        }
      }
      .bp-card-content div{
        color: #FFF;
      }
      .bp-card-title{
        color: #FFF;
      }


    }

    .cvt-launch-container{
      background-color: #121212;
      color: #FFF;
      max-width: 100%;
    }
  }

}

.bank-state {
  width: 40vw;
  height: 30vh;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: $medium-gray;
  border-radius: 7px;
  border: 2px dashed $info;
  padding: 10em 0;
  cursor: pointer;
}

.bank-state-welcome-msg {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.app--header {
  margin-top: 0;
}

.dot-grid {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  position: fixed;
  min-width: 100vw;
  min-height: 100vh;
  background-size: 20px 20px;
  background-position: -233px -2px;
  background-image: linear-gradient(
      transparent 0px,
      transparent 2px,
      rgb(255, 255, 255) 2px,
      rgb(255, 255, 255) 20px
    ),
    linear-gradient(
      to right,
      rgb(200, 195, 199) 0px,
      rgb(200, 195, 199) 2px,
      rgb(255, 255, 255) 2px,
      rgb(255, 255, 255) 20px
    );
}

.page-engine {
  display: flex;
  flex-direction: column;
  position: relative;
}
.page-engin-margin-top {
  margin-top: 4em;
}

.page-engine-wrapper {
  background: $white;
  margin: auto;
  user-select: none;
  width: 100%;
  box-shadow: 0 0 0 0.75pt #d1d1d1, 0 0 3pt 0.75pt #ccc;
  transition: all 0.3s cubic-bezier(0.73, 0, 0.23, 0.99);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;

  &--editor-active {
    // margin-top: 0;
    margin-top: 145px;
    height: 116vh;
    position: absolute;
    transform: scale(0.78);
    transform-origin: top center;
    // padding: 20px;
  }

  &--editor-active-small-scale {
    margin-top: 145px;
    height: 116vh;
    position: absolute;
    transform: scale(0.68);
    transform-origin: top center;
  }

  &--editor-active-grid-small-scale {
    transform: scale(0.78);
    margin-top: 80px;
  }
  &--editor-active-grid-tiny-scale {
    //transform: scale(0.7);
    margin-top: 80px;
    margin-right: 0.8rem;
    height: 119vh;
  }

  &--advanced-menu-open {
    // transform: scale(0.82);
    transform-origin: 20% top;
    // height: 108vh;
    // margin-top: 0;
  }

  &--advanced-menu-open-small-shift {
    transform-origin: 5% top;
  }

  &--advanced-menu-open-grid {
    transform-origin: 25% top;
  }
  &--left-side-menu-open {
    // transform: scale(0.82);
    transform-origin: 95% top;
    // margin-right: 10rem;
    // height: 108vh;
    // margin-top: 0;
  }

  &--right-side-menu-open {
    transform-origin: 5% top;
  }

  .container {
    position: relative;
  }
}


.page-engine-viewmode--sm.page-engine-wrapper {
  &--editor-active-grid-tiny-scale {
    margin-right: auto;
  }
}

.tooltip {
  display: none;
  opacity: 0;
  transition: opacity 0.15s;
  pointer-events: none;
  padding: 4px;
  z-index: 10000;

  .tooltip-content {
    background: $tooltip-bg;
    color: $tooltip-color;
    border-radius: 5px;
    padding: 3px 10px 3px;
    font-size: 11px;
    font-weight: bold;
    text-transform: uppercase;
  }

  &.tooltip-open-transitionend {
    display: block;
  }

  &.tooltip-after-open {
    opacity: 1;
  }
}

button {
  cursor: pointer;
}

// custom scroll bars
.fancy-scroll {
  overflow-y: scroll;
}

/* customize scrollbar css */
.fancy-scroll::-webkit-scrollbar {
  width: 10px;
  background-color: #454b60;
}
.fancy-scroll::-webkit-scrollbar:horizontal {
  height: 10px;
}
.fancy-scroll::-webkit-scrollbar-track {
  border: 1px #454b60 solid;
  border-radius: 10px;
  box-shadow: 0 0 6px #454b60 inset;
  -webkit-box-shadow: 0 0 6px #454b60 inset;
}
.fancy-scroll::-webkit-scrollbar-thumb {
  background-color: #313442;
  border: 1px solid #696a70;
  border-radius: 16px;
}
.fancy-scroll::-webkit-scrollbar-thumb:hover {
  background-color: #505873;
  border: 1px solid #333333;
}
.fancy-scroll::-webkit-scrollbar-thumb:active {
  background-color: #3b4154;
  border: 1px solid #333333;
}
.backdrop {
  position: inherit;
  top: 0;
  left: 0;
  z-index: 2010;
  width: 100vw;
  height: 130vh;
  background-color: rgba(0, 0, 0, 0.45);
  opacity: 0.5;
}
.change-z-index {
  z-index: 3 !important;
}
.subdiv-border {
  border-left: 1px solid #cfd7df;
}
.subdiv-spacing-left {
  margin-left: 20px;
}
.divider {
  width: 100%;
  border-top: 1px solid #eee;
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}
.divider-no-border {
  width: 100%;
  border-top: unset;
  margin-top: 15px !important;
  margin-bottom: 0rem !important;
}
.divider-with-legend {
  display: flex;
  flex-direction: row;
  color: #8A8E97;

  &:before,
  &:after {
    content: "";
    flex: 1 1;
    border-bottom: 1px solid #E2E6ED;
    margin: auto 5px;
  }
}
.divider-spacing {
  width: 100%;
  border-top: unset;
  margin-top: 24px !important;
  margin-bottom: 0rem !important;
}
.alt-buttons {
  display: flex;
  position: absolute;
  right: 24px;
  bottom: -54px;
  z-index: 20;
}
.selected-mark {
  outline: 2px #2a8cd0 solid;
}
.unselected-mark {
  outline: 2px transparent solid;
}
</style>
